import { yupResolver } from '@hookform/resolvers/yup';
import LoadingButton from '@mui/lab/LoadingButton';
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  IconButton,
} from '@mui/material';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
import FormProvider, { RHFTextField, RHFSelect } from 'src/components/hook-form';
import { useSnackbar } from 'src/components/snackbar';
import { MultiFilePreview, Upload } from 'src/components/upload';
import { endpoints } from 'src/utils/axios';
import { postRequest } from 'src/services';
import * as Yup from 'yup';
import { LoadingScreen } from 'src/components/loading-screen';
import { _files } from 'src/_mock';
import Iconify from 'src/components/iconify';
import { StatusContext } from '../../submittals-status-wrapper';

const GeneratedSubmittal = ({ open, onClose, file, fileUrl, reload, closeform }) => {
  const { fetchSubmittals, setFetchSubmittals } = useContext(StatusContext);
  const theme = useTheme();
  const [loading, setLoading] = useState(false);
  const [submittalsData, setSubmittalsData] = useState(null);

  const [checkedState, setCheckedState] = useState(false);

  const { enqueueSnackbar } = useSnackbar();

  const NewUserSchema = Yup.object().shape({
    // risk_id: Yup.string().required('Risk ID is required'),
  });

  const defaultValues = useMemo(
    () => ({
      in_library: false,
    }),
    []
  );

  const methods = useForm({
    resolver: yupResolver(NewUserSchema),
    defaultValues,
  });

  const {
    reset,
    watch,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = handleSubmit(async () => {
    try {
      setLoading(true);
      const formData = new FormData();

      formData.append('file', file);
      formData.append('in_library', checkedState);

      formData.forEach((value, key) => {
        console.log(`${key}:`, value);
      });

      await postRequest(endpoints.submittals.submittals.submittals_import, formData, true);

      setFetchSubmittals(fetchSubmittals + 1);
      onClose();
      closeform();
      reload();
      enqueueSnackbar('File imported successfully!', {
        variant: 'success',
      });
    } catch (error) {
      enqueueSnackbar(error, {
        variant: 'error',
      });
    } finally {
      setLoading(false);
    }
  });

  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick') {
            setSubmittalsData(null);
            onClose();
          }
        }}
        fullWidth
        maxWidth="md"
        sx={{
          borderRadius: 'none',
          padding: '60px',
          fontSize: '13px',
          fontFamily: 'arial',
        }}
        transitionDuration={{
          enter: theme.transitions.duration.shortest,
          exit: theme.transitions.duration.shortest - 80,
        }}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            boxSizing: 'content-box',
          }}
        >
          <span
            className="cardColor"
            style={{ padding: '7px', marginLeft: '-25px', color: 'white', fontWeight: '700' }}
          >
            &nbsp;&nbsp; Ai Generated Submittal &nbsp;&nbsp;&nbsp;&nbsp;
          </span>
          <IconButton onClick={handleClose}>
            <Iconify icon="mdi:close" />
          </IconButton>
        </DialogTitle>

        {loading ? (
          <Box
            sx={{
              width: '100%',
              minHeight: '300px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <LoadingScreen />
          </Box>
        ) : (
          <FormProvider methods={methods} onSubmit={onSubmit}>
            <>
              <DialogContent
                sx={{
                  borderRadius: '1px',
                }}
              >
                <MultiFilePreview
                  files={[file]}
                  onRemove={false}
                  onDownload={() => {
                    const link = document.createElement('a');
                    link.href = fileUrl;
                    link.setAttribute('download', 'combined_output.csv'); // Set default filename
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                  }}
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checkedState}
                      onChange={() => setCheckedState(!checkedState)}
                    />
                  }
                  label={<Typography variant="body1">In Library</Typography>}
                />
              </DialogContent>
            </>
            <DialogActions>
              <Button variant="outlined" color="inherit" onClick={handleClose}>
                Cancel
              </Button>
              <LoadingButton
                type="submit"
                variant="contained"
                className="dark-button"
                loading={isSubmitting}
              >
                Submit
              </LoadingButton>
            </DialogActions>
          </FormProvider>
        )}
      </Dialog>
    </>
  );
};

export default GeneratedSubmittal;
